import CalendarIcon from 'common/components/entities/Calendar/ui/icons/CalendarIcon'
import React from 'react'
import { CheckCircleIcon } from 'src/editor/shared/icons/check-circle-icon'
import { Copy04Icon } from 'src/editor/shared/icons/copy-04-icon'
import { Settings02Icon } from 'src/editor/shared/icons/settings-02-icon'
import { Trash01Icon } from 'src/editor/shared/icons/trash-01-icon'
import { BlogPostMockItem } from 'src/shared/mocks/website-blog-posts.mock'
import {
  BlogPostActionItemEnum,
  BlogPostFilterEnum,
  BlogPostStatusEnum,
} from './enums'

export const filterPosts = (
  posts: BlogPostMockItem[],
  filter: BlogPostFilterEnum,
  search: string,
): BlogPostMockItem[] => {
  let result = posts

  if (filter === BlogPostFilterEnum.ActivePosts) {
    result = result.filter(post => post.status === BlogPostStatusEnum.Published)
  } else if (filter === BlogPostFilterEnum.InactivePosts) {
    result = result.filter(post => post.status !== BlogPostStatusEnum.Published)
  }

  if (search.trim()) {
    const lower = search.toLowerCase()
    result = result.filter(post => post.title.toLowerCase().includes(lower))
  }

  return result
}

export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr)

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export const getPostActionItems = (status: BlogPostStatusEnum) => {
  const items = [
    {
      id: BlogPostActionItemEnum.Settings,
      label: 'Settings',
      iconBefore: () => <Settings02Icon />,
    },
    {
      id: BlogPostActionItemEnum.Duplicate,
      label: 'Duplicate',
      iconBefore: () => <Copy04Icon />,
    },
  ]

  if (status !== BlogPostStatusEnum.Published) {
    items.push({
      id: BlogPostActionItemEnum.Activate,
      label: 'Activate',
      iconBefore: () => <CheckCircleIcon />,
    })
  }

  if (status === BlogPostStatusEnum.Draft) {
    items.push({
      id: BlogPostActionItemEnum.Schedule,
      label: 'Schedule',
      iconBefore: () => <CalendarIcon />,
    })
  }

  items.push({
    id: BlogPostActionItemEnum.Delete,
    label: 'Remove',
    iconBefore: () => <Trash01Icon />,
  })

  return items
}
